export enum Events {
  ADD_TO_CART_SUCCESS = 'add_to_cart_success',
  ADD_TO_CART_FAIL = 'add_to_cart_fail',
  OPEN_CHOICE_OF_BONUS_PRODUCTS_MODAL = 'open_choice_of_bonus_products_modal',
  CHANGED_CONSENTS = 'changed_consents'
}

export const EventsEmitter = {
  _events: {},

  has(event: Events) {
    return !!this._events[event]
  },

  dispatch(event: Events, data: any) {
    if (!this._events[event]) return
    this._events[event].forEach((callback) => callback(data))
  },

  subscribe(event: Events, callback: (data: any) => any) {
    if (!this._events[event]) this._events[event] = []
    this._events[event].push(callback)
  },

  unsubscribe(event: Events) {
    if (!this._events[event]) return
    delete this._events[event]
  }
}
